(function (doc, win) {
  let docEl = doc.documentElement
  /**
   * 获取元素离顶部的距离
   * @param element
   * @returns {number}
   */
  const getElementViewTop = (element) => {
    let actualTop = element.offsetTop
    let current = element.offsetParent
    while (current !== null && current) {
      actualTop += current.offsetTop
      current = current.offsetParent
    }
    let elementScrollTop = document.documentElement.scrollTop
    return actualTop - elementScrollTop
  }
  // 软键盘高度
  let keyHeight = 0
  /**
   * 浏览器视口高度
   * @returns {Number|number}
   */
  const viewportHeight = () => {
    return window.innerHeight || docEl.clientHeight || doc.body.clientHeight
  }
  // 初始视口高度
  let BodyHeight = viewportHeight()
  /**
   * 获取软键盘的高度
   * @param callBack
   * 回调函数执行位置变化
   */
  const keyboardHeight = (callBack) => {
    if (!keyHeight) {
      setTimeout(() => {
        let nowBodyHeight = viewportHeight()
        if (!nowBodyHeight) {
          keyboardHeight()
        }
        keyHeight = BodyHeight - nowBodyHeight
        callBack(keyHeight)
      }, 600)
    } else {
      callBack(keyHeight)
    }
  }
  /**
   * 重置滚动条位置
   * @param scrollTop
   */
  const restAppScrollTop = (scrollTop) => {
    doc.querySelector('#app').scrollTop = scrollTop || 0
  }
  let elem = ''
  const inputUpdate = (e) => {
    if (e && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
      elem = e.target
    }
  }
  const blurTo = () => {
    inputUpdate()
    let app = doc.querySelector('#app')
    let appScrollTop = app.scrollTop
    let appHeight = app.scrollHeight
    keyboardHeight((kh) => {
      let nowHeight = viewportHeight()
      if (getElementViewTop(elem) > nowHeight || BodyHeight > appHeight) {
        if (BodyHeight > nowHeight) {
          restAppScrollTop(appScrollTop + kh)
        } else if (BodyHeight === nowHeight) {
          restAppScrollTop(appScrollTop - kh)
        }
      }
    })
  }
  // 获取焦点
  doc.addEventListener('focus', blurTo, true)
  // 失去焦点
  doc.addEventListener('blur', blurTo, true)
  // doc.addEventListener('DOMContentLoaded', blurTo, false)
})(document, window)



// WEBPACK FOOTER //
// ./src/lib/utils/rem.device.js